import React, { lazy, Suspense } from 'react';

const LazyRemoveWatermark = lazy(async () => await import('./RemoveWatermark'));

const RemoveWatermark = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyRemoveWatermark {...props} />
  </Suspense>
);

export default RemoveWatermark;
